import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BookOpenIcon, ChevronDownIcon, Clock3Icon, ListChecksIcon } from 'lucide-react';
import { IMAGES, TOMOS } from '../data/landing';
export function SolutionSection() {
  const [openTomo, setOpenTomo] = useState<number | null>(0);
  return <section className="w-full bg-neutral-950 py-10 text-white sm:py-16" data-id="element-220" data-mp="3j95zd92qpt3n">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-221" data-mp="142r5fhh90z0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-222" data-mp="12hxds2zlm27">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-223" data-mp="3t96lf2rzunbj">
            <BookOpenIcon className="h-3.5 w-3.5" data-id="element-224" data-mp="awi8caky9liu" /> La solución
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-225" data-mp="5vukfxs0pksu">
            Esto no es un simple PDF de recetas.
          </h2>
          <p className="mt-3 text-base text-neutral-300 sm:text-lg" data-id="element-226" data-mp="fu0mcfdtqqxp">
            Es la <span className="font-bold text-yellow-400" data-id="element-227" data-mp="frnxdi9nfgb5">biblioteca completa</span>{' '}
            de cocina moderna: una saga de 4 tomos con 250 recetas paso a paso.
          </p>
        </div>

        <img src={IMAGES.mockupPrincipal} alt="Los 4 tomos del MegaPack Air Fryer Argentina" className="mx-auto mt-8 w-full max-w-2xl drop-shadow-2xl" data-id="element-228" data-mp="3bbjswhvv8qef" />

        <div className="mt-10" data-id="element-229" data-mp="3k8am8mj19r5b">
          <div className="mb-5 text-center" data-id="element-230" data-mp="3p9zyu6lwmcvi">
            <p className="text-lg font-black text-white sm:text-xl" data-id="element-231" data-mp="3p8yl1udi7ca3">
              Espiá el índice de cada tomo
            </p>
            <p className="mt-1 text-sm text-neutral-400" data-id="element-232" data-mp="3u689b6p5phwc">
              Una muestra de los clásicos argentinos que vas a poder hacer desde el primer día.
            </p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2" data-id="element-233" data-mp="6xlayzs2ze7g">
            {TOMOS.map((tomo, index) => {
            const isOpen = openTomo === index;
            return <motion.article key={tomo.numero} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="overflow-hidden rounded-2xl border border-neutral-800 bg-neutral-900" data-id="element-234" data-mp="guganm03bknb" data-mpi={index}>
                  <button type="button" onClick={() => setOpenTomo(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`indice-${index}`} className="flex w-full items-start justify-between gap-4 p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-yellow-400" data-id="element-235" data-mp="2hubf1g3pkgej">
                    <span data-id="element-236" data-mp="1b77lhp5g7sgq">
                      <span className="inline-block rounded-md px-2.5 py-1 text-xs font-black uppercase text-neutral-900" style={{
                    backgroundColor: tomo.color
                  }} data-id="element-237" data-mp="1b8iklbny8c1i">
                        {tomo.numero}
                      </span>
                      <span className="mt-3 block text-xl font-bold text-white" data-id="element-238" data-mp="3mtrknfsm3qse">{tomo.titulo}</span>
                      <span className="mt-1.5 block text-sm text-neutral-400" data-id="element-239" data-mp="385545ar90szl">{tomo.descripcion}</span>
                      <span className="mt-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-neutral-300" data-id="element-240" data-mp="3d3oq3b5ue4ry">
                        <Clock3Icon className="h-3.5 w-3.5" style={{
                      color: tomo.color
                    }} data-id="element-241" data-mp="2z7bay8os6fgn" />
                        {tomo.rango}
                      </span>
                    </span>
                    <ChevronDownIcon className={`mt-1 h-6 w-6 shrink-0 text-neutral-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-242" data-mp="2p8vh3xydcs3g" />
                  </button>

                  <AnimatePresence initial={false} data-id="element-243" data-mp="sf0p1adjhjko">
                    {isOpen && <motion.div id={`indice-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="overflow-hidden" data-id="element-244" data-mp="2oif78ftiqb1g">
                        <div className="border-t border-neutral-800 px-5 pb-5 pt-4" data-id="element-245" data-mp="25isyg0g3vkx4">
                          <p className="text-sm leading-relaxed text-neutral-300" data-id="element-246" data-mp="20sck8e4gnv9p">{tomo.enfoque}</p>
                          <div className="mt-4 rounded-xl bg-neutral-950 p-4" data-id="element-247" data-mp="1wqqzy7plkeph">
                            <p className="flex items-center gap-2 text-xs font-black uppercase tracking-wider text-yellow-400" data-id="element-248" data-mp="1womxzvb9dpru">
                              <ListChecksIcon className="h-4 w-4" data-id="element-249" data-mp="1msa3iv7w37w1" /> Índice destacado
                            </p>
                            <ol className="mt-3 space-y-2" data-id="element-250" data-mp="1ht6yvbvtn3ol">
                              {tomo.destacados.map((receta, recipeIndex) => <li key={receta} className="flex items-start gap-2 text-sm text-neutral-200" data-id="element-251" data-mp="17pa4283agr31" data-mpi={recipeIndex}>
                                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-black text-neutral-950" style={{
                            backgroundColor: tomo.color
                          }} data-id="element-252" data-mp="1cqpkfmuiu9f3">
                                    {recipeIndex + 1}
                                  </span>
                                  {receta}
                                </li>)}
                            </ol>
                          </div>
                          <p className="mt-4 border-l-2 pl-3 text-xs font-semibold leading-relaxed text-neutral-400" style={{
                      borderColor: tomo.color
                    }} data-id="element-253" data-mp="13phsrnmig6tz">
                            {tomo.masRecetas}
                          </p>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}